import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import et from './locales/et.json';
import en from './locales/en.json';

const STORAGE_KEY = 'hm_admin_lang';

function detectLanguage(): string {
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored === 'et' || stored === 'en') return stored;
  // Default to Estonian — primary market
  return 'et';
}

i18n
  .use(initReactI18next)
  .init({
    resources: {
      et: { translation: et },
      en: { translation: en },
    },
    lng: detectLanguage(),
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
  });

export function setLanguage(lang: 'et' | 'en') {
  localStorage.setItem(STORAGE_KEY, lang);
  void i18n.changeLanguage(lang);
}

export function getLanguage(): 'et' | 'en' {
  return (i18n.language === 'et' ? 'et' : 'en') as 'et' | 'en';
}

/** Returns the locale string for date formatting (e.g. toLocaleDateString) */
export function getDateLocale(): string {
  return i18n.language === 'et' ? 'et-EE' : 'en-GB';
}

export default i18n;
